import { apiRoot } from "../../old/beheer/store/api/apiRoot";
import { Paginated } from "../../old/beheer/store/api/upsellApi";
import { UrlBuilder } from "../../utils/UrlBuilder";
import { GridFilterItem, GridSortDirection } from "@mui/x-data-grid";
import _ from "lodash";

const paymentEndpoints = apiRoot.enhanceEndpoints({
  addTagTypes: ["Payment"],
});

export type Payment = { id: number; vestiging?: { naam: string; systeemNaam: string } };

export const paymentApi = paymentEndpoints.injectEndpoints({
  endpoints: (builder) => ({
    fetchPayments: builder.query<
      Paginated<Payment>,
      {
        gridFilterItems?: Record<string, GridFilterItem>;
        pagination?: {
          page: number;
          perPage: number;
        };
        sorting?: { field: string; sort: GridSortDirection }[];
        include?: string[];
      }
    >({
      query: ({ pagination, include, sorting, gridFilterItems }) => {
        return {
          url: new UrlBuilder("payments")
            .setPage(pagination?.page)
            .setPerPage(pagination?.perPage)
            .setFilters(_.values(gridFilterItems))
            .setSorting(sorting)
            .addInclude(include).url,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: "Payment" as const, id })),
              { type: "Payment", id: "PARTIAL-LIST" },
            ]
          : [{ type: "Payment", id: "PARTIAL-LIST" }],
    }),
  }),
});

export const { useFetchPaymentsQuery } = paymentApi;
